import Reflux from "reflux";
import UserNotification from "util/UserNotification";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
const AWSRegionsUrl = "/plugins/org.graylog.plugins.archive/backends/s3/regions";
export const AWSRegionsActions = Reflux.createActions({
  getRegions: { asyncResult: true }
});
const AWSRegionsStore = Reflux.createStore({
  listenables: [AWSRegionsActions],
  regions: void 0,
  getInitialState() {
    return {
      regions: this.regions
    };
  },
  getRegions() {
    const promise = fetch("GET", qualifyUrl(AWSRegionsUrl));
    const errorHandler = this._errorHandler("Fetching AWS regions failed.", "Could not retrieve AWS regions.");
    promise.then(
      (response) => {
        this.regions = response.regions;
        this.trigger({ regions: response.regions });
        return response;
      },
      (error) => {
        errorHandler(error);
      }
    );
    AWSRegionsActions.getRegions.promise(promise);
  },
  _errorHandler(message, title) {
    return (error) => {
      var _a, _b, _c;
      const errorMessage = (_c = (_b = (_a = error.additional) == null ? void 0 : _a.body) == null ? void 0 : _b.message) != null ? _c : error.message;
      UserNotification.error(`${message}: ${errorMessage}`, title);
    };
  }
});
export default AWSRegionsStore;
